import React from "react";
import { withTranslation } from "react-i18next";

const StaffTypeRadio = ({ t, value, onChange, error, fieldIndex }) => {
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    onChange({
      target: {
        name: name.split("_")[0],
        value,
      },
    });
  };
  return (
    <div className="c-field c-field-sm">
      <label>{t("accountOwner.jobType")}</label>
      <div className="radio-list mt-0">
        <ul>
          <li>
            <div className="ch-radio">
              <label>
                <input
                  type="radio"
                  name={"staffType_" + fieldIndex}
                  value="2"
                  onChange={onChangeHandler}
                  checked={+value === 2}
                />
                <span>{t("form.values.permanent")}</span>
              </label>
            </div>
          </li>
          <li>
            <div className="ch-radio">
              <label>
                <input
                  type="radio"
                  name={"staffType_" + fieldIndex}
                  value="1"
                  onChange={onChangeHandler}
                  checked={+value === 1}
                />
                <span>{t("form.values.temporary")}</span>
              </label>
            </div>
          </li>
        </ul>
      </div>
      {error && <span className="error-msg mt-0">{error}</span>}
    </div>
  );
};

export default withTranslation()(StaffTypeRadio);
